import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';
import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import D1 from "../../components/ExcerciseTypes/Design/TypeIn";

const json = {
  1: { // Exercise num
    unit: 'Unit 9',
    id: 'SB3-U9-P66-E1',
    audio: '',
    video: '',
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page66/E1/Key/answerKey.png',
    titleQuestion: [{ num: '1', title: 'Circle the odd-one-out. Write.', color: "#1F4199" }],
    question: {
      Write: {
        inputStyle: { width: 200, marginLeft: 20, color: '#00a8ec' },
        answers: ['sunny', 'store', 'scarf', 'snowing'],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: { margin: '5px', border: 'solid 2px', borderColor: 'black', borderRadius: 10, padding: '0 5px', backgroundColor: 'white' },
        selectWordStyle: { borderColor: '#00a8ec' },
        limitSelect: 1,
        listWords: [
          'boots sunny shirt skirt', //0
          'store raining windy hot', //1
          'fifteen scarf thirty forty-five', //2
          'skirt socks snowing boots', //3
        ],
        answers: ['0-2', '1-0', '2-2', '3-4'],
        initialValue: [],
      },
      Layout: `
        <div style='background-color: rgb(255, 248, 245); padding: 20px;'>
          <div style='margin: 5px;'><b>1</b>
            <span style='margin: 10px 20px; border: 2px solid black; border-radius: 10px; padding: 5px 10px; background-color: white;'>zoo</span>
            <span style='margin: 10px 20px; border: 2px solid black; border-radius: 10px; padding: 5px 10px; background-color: white;'>police station</span>
            <span style='margin: 10px 20px; border: 2px solid rgb(0, 168, 236); border-radius: 10px; padding: 5px 10px; background-color: white;'>jeans</span>
            <span style='margin: 10px 20px; border: 2px solid black; border-radius: 10px; padding: 5px 10px; background-color: white;'>train station</span>
            <span>&emsp;<u style='text-decoration-color: black;color:rgb(82,197,235)'>&emsp;jeans&emsp;</u></span>
          </div>
          <div><span style='display:flex;justify-content: space-between; width: 870px;align-items: center;'><b>2</b> <input id='0' type='Circle' /> <input id='0' /></span> </div>
          <div><span style='display:flex;justify-content: space-between; width: 870px;align-items: center;'><b>3</b> <input id='1' type='Circle' /> <input id='1' /></span> </div>
          <div><span style='display:flex;justify-content: space-between; width: 870px;align-items: center;'><b>4</b> <input id='2' type='Circle' /> <input id='2' /></span> </div>
          <div><span style='display:flex;justify-content: space-between; width: 870px;align-items: center;'><b>5</b> <input id='3' type='Circle' /> <input id='3' /></span> </div>
        </div>
      `,
    },
  },
  2: { // Exercise num
    unit: 'Unit 9',
    id: 'SB3-U9-P66-E4',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page66/E2/Key/answerKey.png',
    isAllowSubmit: false,
    // maxLength: 2,
    // textAlign: 'center',
    // padding: 0,
    question: [],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page66/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page66/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page66/E2/3.jpg', input: true, answer: "forty-five" },
        { url: 'img/FriendsPlus/Page66/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page66/E2/5.jpg', input: true, answer: "thirty" },
        { url: 'img/FriendsPlus/Page66/E2/6.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page66/E2/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page66/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page66/E2/9.jpg', input: true, answer: "snowing" },
        { url: 'img/FriendsPlus/Page66/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page66/E2/11.jpg', input: true, answer: "windy" },
        { url: 'img/FriendsPlus/Page66/E2/12.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page66/E2/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page66/E2/14.jpg' },
        { url: 'img/FriendsPlus/Page66/E2/15.jpg', input: true, answer: "forty-five" },
        { url: 'img/FriendsPlus/Page66/E2/16.jpg' },
        { url: 'img/FriendsPlus/Page66/E2/17.jpg', input: true, answer: "fifteen" },
        { url: 'img/FriendsPlus/Page66/E2/18.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page66/E2/19.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page66/E2/20.jpg' },
        { url: 'img/FriendsPlus/Page66/E2/21.jpg', input: true, answer: "sunny" },
        { url: 'img/FriendsPlus/Page66/E2/22.jpg' },
        { url: 'img/FriendsPlus/Page66/E2/23.jpg', input: true, answer: "hot" },
        { url: 'img/FriendsPlus/Page66/E2/24.jpg' },
      ],
    ]
  },
  3: { // Exercise num
    unit: 'Unit 9',
    id: 'SB3-U9-P66-E3',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: 'img/FriendsPlus/Page66/E3/1.jpg' }]],
  },
}

export default json;